export const transaksiKeluarFormData = (
  dropdownPelanggan,
  noTransKeluar,
  dropdownOnlyKas
) => {
  const tanggalSaatIni = new Date().toISOString().slice(0, 10);

  return [
    {
      id: "nomor_transaksi_keluar",
      label: "Nomor Transaksi Keluar",
      fields: [
        {
          type: "readonly",
          defaultValue: noTransKeluar,
        },
      ],
    },
    {
      id: "tanggal_transaksi_keluar",
      label: "Tanggal Transaksi Keluar",
      fields: [
        {
          type: "date",
          defaultDate: true,
          defaultDateValue: tanggalSaatIni,
        },
      ],
    },
    {
      id: "id_pelanggan",
      label: "Penyetor",
      fields: [
        {
          type: "option",
          options: dropdownPelanggan,
        },
      ],
    },
    {
      id: "jumlah_transaksi_keluar",
      label: "Jumlah Transaksi Keluar",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Nilai Transaksi...",
        },
      ],
    },
    {
      id: "via_bayar_transaksi_keluar",
      label: "Via Bayar",
      fields: [
        {
          type: "option",
          options: dropdownOnlyKas,
        },
      ],
    },
    {
      id: "keterangan_transaksi_keluar",
      label: "Keterangan Transaksi Keluar",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Keterangan Transaksi Keluar...",
        },
      ],
    },
    {
      id: "bukti_transaksi_keluar",
      label: "Upload Bukti Transaksi Keluar ( .jpg / .png / .jpeg)",
      fields: [
        {
          type: "file_multiple",
        },
      ],
    },
  ];
};

export const transaksiKeluarPindahAnggaranFormData = (
  dropdownAnggaranPengeluaran
) => {
  return [
    {
      id: "id_anggaran_pengeluaran",
      label: "Pilih Anggaran Pengeluaran",
      fields: [
        {
          type: "option",
          options: dropdownAnggaranPengeluaran,
        },
      ],
    },
  ];
};
